import tw, { styled } from 'twin.macro';

const Heading1 = styled.h1`
  ${tw`text-lg relative z-10`};
  ${tw`print:!text-lg`}
  line-height: 1.3;
`;

export default Heading1;
